(function () {
  'use strict';

  var moneyFormat = window.Shopify && Shopify.money_format;

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function' && moneyFormat) {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    return new Intl.NumberFormat(document.documentElement.lang || 'el-GR', {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR',
    }).format(cents / 100);
  }

  function lockScroll(lock) {
    document.documentElement.classList.toggle('aph-drawer-open', lock);
    document.body.classList.toggle('aph-drawer-open', lock);
  }

  function closeAllDrawers() {
    document.querySelectorAll('[data-aph-menu-drawer],[data-aph-cart-drawer]').forEach(function (el) {
      el.hidden = true;
    });
    lockScroll(false);
  }

  function openDrawer(drawer) {
    if (!drawer) return;
    closeAllDrawers();
    drawer.hidden = false;
    lockScroll(true);
  }

  function cartRoot() {
    return document.querySelector('[data-aph-cart-drawer]');
  }

  function updateHeaderCount(count) {
    document.querySelectorAll('[data-aph-header-cart-count]').forEach(function (el) {
      el.textContent = '(' + count + ')';
    });
    var drawerCount = document.querySelector('[data-aph-cart-drawer-count]');
    if (drawerCount) drawerCount.textContent = '(' + count + ')';
  }

  function renderCart(cart) {
    var root = cartRoot();
    if (!root || !cart) return;

    var itemsEl = root.querySelector('[data-aph-cart-items]');
    var footEl = root.querySelector('[data-aph-cart-foot]');
    var subtotalEl = root.querySelector('[data-aph-cart-subtotal]');

    updateHeaderCount(cart.item_count);

    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    if (!itemsEl) return;

    if (!cart.item_count) {
      itemsEl.innerHTML =
        '<div class="aph-cart-drawer__empty" data-aph-cart-empty>' +
        '<p>Το καλάθι σου είναι άδειο</p>' +
        '<a href="/collections/all" class="aph-cart-drawer__shop-link">Συνέχεια αγορών</a>' +
        '</div>';
      if (footEl) footEl.hidden = true;
      return;
    }

    if (footEl) footEl.hidden = false;

    itemsEl.innerHTML = cart.items
      .map(function (item) {
        var variantLine = item.variant_title && item.variant_title !== 'Default Title'
          ? '<p class="aph-cart-drawer__line-variant">' + item.variant_title + '</p>'
          : '';
        var image = item.image
          ? '<img src="' + item.image + '&width=160" alt="" class="aph-cart-drawer__line-image" loading="lazy">'
          : '';
        return (
          '<article class="aph-cart-drawer__line" data-aph-cart-line="' + item.key + '">' +
          '<a href="' + item.url + '" class="aph-cart-drawer__line-media">' + image + '</a>' +
          '<div class="aph-cart-drawer__line-body">' +
          '<a href="' + item.url + '" class="aph-cart-drawer__line-title">' + item.product_title + '</a>' +
          variantLine +
          '<div class="aph-cart-drawer__line-meta">' +
          '<div class="aph-cart-drawer__qty" data-aph-cart-qty-wrap>' +
          '<button type="button" class="aph-cart-drawer__qty-btn" data-aph-cart-qty-change="-1" data-line-key="' + item.key + '" aria-label="Μείωση">−</button>' +
          '<span class="aph-cart-drawer__qty-val" data-aph-cart-qty>' + item.quantity + '</span>' +
          '<button type="button" class="aph-cart-drawer__qty-btn" data-aph-cart-qty-change="1" data-line-key="' + item.key + '" aria-label="Αύξηση">+</button>' +
          '</div>' +
          '<p class="aph-cart-drawer__line-price">' + formatMoney(item.final_line_price) + '</p>' +
          '</div></div>' +
          '<button type="button" class="aph-cart-drawer__remove" data-aph-cart-remove="' + item.key + '" aria-label="Αφαίρεση">' +
          '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="m3 3 8 8M11 3 3 11" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>' +
          '</button></article>'
        );
      })
      .join('');
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    }).then(function (r) {
      return r.json();
    });
  }

  function addVariant(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 }),
    }).then(function (r) {
      if (!r.ok) throw new Error('Add failed');
      return r.json();
    });
  }

  function refreshCart(openAfter) {
    return fetchCart().then(function (cart) {
      renderCart(cart);
      if (openAfter) openDrawer(cartRoot());
      document.dispatchEvent(new CustomEvent('aph:cart:updated', { detail: cart }));
      return cart;
    });
  }

  function isCartAddForm(form) {
    var action = (form.getAttribute('action') || '').toLowerCase();
    return action.indexOf('/cart/add') !== -1;
  }

  function isCheckoutSubmit(form) {
    var returnTo = form.querySelector('input[name="return_to"]');
    return returnTo && returnTo.value.indexOf('/checkout') !== -1;
  }

  function handleCartAddForm(form, submitter) {
    var formData = new FormData(form);
    var id = formData.get('id');
    if (!id) return Promise.resolve();

    var quantity = parseInt(formData.get('quantity'), 10) || 1;
    if (submitter) {
      submitter.classList.add('is-loading');
      submitter.disabled = true;
    }

    return addVariant(id, quantity)
      .then(function (item) {
        document.dispatchEvent(
          new CustomEvent('aph:cart:added', {
            detail: { id: id, quantity: quantity, item: item },
          })
        );
        return refreshCart(true);
      })
      .catch(function () {})
      .finally(function () {
        if (submitter) {
          submitter.classList.remove('is-loading');
          submitter.disabled = false;
        }
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var menuTrigger = document.querySelector('[data-aph-menu-open]');
    var cartTrigger = document.querySelector('[data-aph-cart-open]');
    var menuDrawer = document.querySelector('[data-aph-menu-drawer]');
    var cartDrawer = document.querySelector('[data-aph-cart-drawer]');

    if (menuTrigger && menuDrawer) {
      menuTrigger.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer(menuDrawer);
      });
    }

    if (cartTrigger && cartDrawer) {
      cartTrigger.addEventListener('click', function (e) {
        e.preventDefault();
        refreshCart(true);
      });
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-aph-drawer-close]')) {
        closeAllDrawers();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllDrawers();
    });

    document.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('[data-aph-cart-remove]');
      if (removeBtn) {
        e.preventDefault();
        changeLine(removeBtn.getAttribute('data-aph-cart-remove'), 0).then(renderCart);
        return;
      }

      var qtyBtn = e.target.closest('[data-aph-cart-qty-change]');
      if (qtyBtn) {
        e.preventDefault();
        var key = qtyBtn.getAttribute('data-line-key');
        var line = qtyBtn.closest('[data-aph-cart-line]');
        var qtyEl = line && line.querySelector('[data-aph-cart-qty]');
        var current = qtyEl ? parseInt(qtyEl.textContent, 10) || 1 : 1;
        var delta = parseInt(qtyBtn.getAttribute('data-aph-cart-qty-change'), 10);
        var next = Math.max(0, current + delta);
        changeLine(key, next).then(renderCart);
        return;
      }

      var lookAdd = e.target.closest('[data-aph-look-add]');
      if (lookAdd) {
        e.preventDefault();
        e.stopPropagation();
        var variantId = lookAdd.getAttribute('data-aph-look-add');
        var openAfter = true;
        lookAdd.disabled = true;
        addVariant(variantId, 1)
          .then(function () {
            return refreshCart(openAfter);
          })
          .catch(function () {})
          .finally(function () {
            lookAdd.disabled = false;
          });
      }
    });

    document.addEventListener('aph:cart:open', function () {
      refreshCart(true);
    });

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!isCartAddForm(form)) return;
      if (isCheckoutSubmit(form)) return;

      e.preventDefault();
      handleCartAddForm(form, e.submitter);
    });
  });
})();
